import { React, useState, useEffect } from "react";
import { Container, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import api from "../../../seller-apis/api";
import { pendingFromSellerProducts, pendingFromSellerProductsWithourRejected } from "../../../seller-apis/apidataField";
import PaginationCom from "../../common/Pagination";
import NotAprrPCard from "../../common/NotAprrPCard";
import "../../inventry.css";
import { variables } from "../../../Variables.json";
import { NavLink } from "react-router-dom";
import Popup from "../../common/Popup";
import { useAlert } from "react-alert";
import PopupActionRequired from "../../common/PopupActionRequired";
import ProductSearch from "../../common/ProductSearch";
import { Actions } from "../../../Actions/Actions";
import { useDispatch } from "react-redux";
import ActionRequiredConfirmModal from "../../common/ActionRequiredConfirmModal";
import RejectProductModal from "../../common/RejectProduct";
import ActionRequiredConfirmModalComb from "../../common/ActionRequiredConfirmModalComb";
var globalFilter = {
  pageNo: 1,
};
const ActionRequiredNewPro = () => {
  var outerdiv;
  var loaderDiv;

  const alert = useAlert();
  const [rejectedProductsList, setrejectedProductsList] = useState([]);
  const [rejRecords, setrejRecords] = useState();

  // Pagination related

  const [compforPaginationweb, setcompforPaginationweb] = useState("rejPro");
  const [selectedPage, setselectedPage] = useState(1);
  // Loader state

  const [loaderProductReject, setloaderProductReject] = useState("block");

  // Web search
  const [searchPro, setsearchPro] = useState();
  const [searchType, setSearchType] = useState("Product Name");

  // Detail Popup

  const [isDetailPopupVis, setisDetailPopupVis] = useState("none");
  const [currdetailId, setcurrdetailId] = useState(0);

  const [removeFilterClass, setremoveFilterClass] = useState(
    "invent_remove_filter_btn"
  );

  const [popupActReqShow, setPopupActReqShow] = useState("none")
  const [currStatusFilter, setCurrStatusFilter] = useState("forwarded-to-seller");

  // l1-2607
  const [cbimg, setcbimg] = useState();
  const [selectedProductPopup, setselectedProductPopup] = useState();
  const [updtProVisibility, setupdtProVisibility] = useState(false);
  const [updtPopuprel, setupdtPopuprel] = useState([]);
  const [currentProp, setCurrentProp] = useState({});
  const [rejectModalShow, setRejectModalShow] = useState(false)
  const [reasonText, setReasonText] = useState("");
  const dispatch = useDispatch();
  useEffect(() => {
    globalFilter = {
      pageNo: 1,
      tmpSts: ["forwarded-to-seller"]
    };
    let filter = {
      pageNo: "1",
    };

    // Rejected Products
    api.product
      .sellerProductsRetrieveAll(pendingFromSellerProducts(globalFilter))
      .then((res) => {
        console.log(res);
        setrejectedProductsList(res.products);
        setrejRecords(res.totalRecords);
        setloaderProductReject("none");
      })
      .catch((err) => {
        console.log(err);
        setloaderProductReject("none");
      });
  }, []);

  // apply loaders

  function applyLoader() {
    outerdiv = document.getElementById("orDeskContain");
    loaderDiv = document.getElementById("Loaderrejected");
    loaderDiv.classList.add("loader-bt");
    setloaderProductReject("flex");
    outerdiv.classList.add("div-bk");
  }

  // remove loader

  function removeLoader() {
    loaderDiv.classList.remove("loader-bt");
    setloaderProductReject("none");
    outerdiv.classList.remove("div-bk");
  }

  // Search on enter web

  function checkevent(e) {
    if (e.keyCode === 13) {
      if (searchPro !== "" && searchPro !== undefined) {
        console.log(globalFilter, globalFilter.filters);
        globalFilter.pageNo = selectedPage;
        let ordersearchFilter = searchType != 'sku' ? { "productName-Id": searchPro } : { "SKU-Id": searchPro };
        globalFilter.filters = {
          // ...globalFilter.filters,
          ...ordersearchFilter
        };
        applyLoader();
        setselectedPage(1);
        setcompforPaginationweb("rejsearchPro");
        // Rejected Products
        api.product
          .sellerProductsRetrieveAll(pendingFromSellerProducts(globalFilter))
          .then((res) => {
            setremoveFilterClass("invent_remove_filter_btn_active");
            setrejectedProductsList(res.products);
            setrejRecords(res.totalRecords);
            removeLoader();
          })
          .catch((err) => {
            console.log(err);
            removeLoader();
          });
      } else if (compforPaginationweb !== "rejPro") {
        applyLoader();
        globalFilter.pageNo = selectedPage;
        globalFilter.productFilters = {};
        setselectedPage(1);
        setcompforPaginationweb("rejPro");
        // Rejected Products
        api.product
          .sellerProductsRetrieveAll(pendingFromSellerProducts(globalFilter))
          .then((res) => {
            setremoveFilterClass("invent_remove_filter_btn");
            setrejectedProductsList(res.products);
            setrejRecords(res.totalRecords);
            removeLoader();
          })
          .catch((err) => {
            console.log(err);
            removeLoader();
          });
      }
    }
  }

  // search product btn web
  function searchProdBtnweb() {
    if (searchPro !== undefined && searchPro !== "") {
      globalFilter.filters = {
        ...globalFilter.filters,
        productName: searchPro,
      };
      applyLoader();
      setselectedPage(1);
      setcompforPaginationweb("rejsearchPro");
      globalFilter.pageNo = selectedPage;
      api.product
        .sellerProductsRetrieveAll(pendingFromSellerProducts(globalFilter))
        .then((res) => {
          setremoveFilterClass("invent_remove_filter_btn_active");
          setrejectedProductsList(res.products);
          setrejRecords(res.totalRecords);
          removeLoader();
        })
        .catch((err) => {
          console.log(err);
          removeLoader();
        });
    } else if (compforPaginationweb !== "rejPro") {
      applyLoader();
      globalFilter.productFilters = {};
      setselectedPage(1);
      globalFilter.pageNo = selectedPage;
      api.product
        .sellerProductsRetrieveAll(pendingFromSellerProducts(globalFilter))
        .then((res) => {
          setremoveFilterClass("invent_remove_filter_btn");
          setrejectedProductsList(res.products);
          setrejRecords(res.totalRecords);
          removeLoader();
        })
        .catch((err) => {
          console.log(err);
          setloaderProductReject("none");
          removeLoader();
        });
    }
  }

  // Pagination function

  function paginate(data) {
    setcurrdetailId(0);
    globalFilter.pageNo = data.number;
    setselectedPage(data.number);
    applyLoader();
    // Rejected Products
    api.product
      .sellerProductsRetrieveAll(pendingFromSellerProducts(globalFilter))
      .then((res) => {
        setrejectedProductsList(res.products);
        removeLoader();
      })
      .catch((err) => {
        console.log(err);
        removeLoader();
      });
  }

  // Show detail

  function showDetail(id) {
    setcurrdetailId(id);
    setisDetailPopupVis("block")
    setPopupActReqShow("block")
  }

  function setpopupVisibilityDetail() {
    setisDetailPopupVis("none");
    setPopupActReqShow("none")
  }

  // Approve or reject products
  const handleProductUpdate = (rType, item, stock = null, url = null, reason) => {
    let productData = {
      _id: item.lead,
      sellerRemarksHistory: item.sellerRemarksHistory || [],
    };
    if (rType == "approve") {
      productData["tmpSts"] = "approved-by-seller";
      productData["adminApproval"] = true;
      productData["adminApprovDate"] = new Date();
    } else {
      if (reason === "" || reason === undefined) {
        alert.info("Please enter a valid reason");
        return false;
      }
      productData.sellerRemarksHistory.push({
        actionDate: new Date(),
        reason: reason
      });
      productData["tmpSts"] = item.bulkupload != undefined && item.bulkupload ? "bulk-rejected" : "rejected";//I1-1737 Bulk Upload
    }


    api.product
      .sellerProductsUpdateOne(productData)
      .then((res) => {
        setupdtProVisibility(false)
        alert.success("Product updated successfully");
        //SL-699
        api.product
          .sellerProductsRetrieveAll(pendingFromSellerProducts(globalFilter))
          .then((res) => {
            setrejectedProductsList(res.products);
            setrejRecords(res.totalRecords);
            Actions.updateProductActReqCount(dispatch, res.totalRecords);
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.log(err);
        alert.error("Failed to update");
      });
  };

  //SL-699 : Seller Stock Update
  function updateSellerStock(id, url, stock) {

    let data = {
      "_id": id,
      "stock": stock,
      "vActive": "ACTIVE",
      "reason": ""
    }
    //if given 0, then out of stock
    if (stock == 0) {
      data["vActive"] = "INACTIVE";
      data["reason"] = "Out Of Stock";
    }
    if (url !== undefined && url !== null)
      data["url"] = url;

    api.product.addToExProduct(data).then((res) => {

    }).catch(err => console.log(err))

  }
  // Request new Price

  function requestnewPrice(id, gst) {
    let filter = {
      pageNo: selectedPage,
    };
    let ele = document.getElementById("req_price_again" + id);
    if (ele.value === "" || ele.value === undefined || ele.value < 1) {
      alert.info("Please enter a valid price");
    } else {
      if (
        rejectedProductsList[id].combination &&
        rejectedProductsList[id].combination.url &&
        rejectedProductsList[id].combination.url !== "notfound"
      ) {
        let chCom = {
          url: rejectedProductsList[id].combination.url,
          purchase_price: ele.value,
        };
        let data = {
          _id: rejectedProductsList[id].product._id,
          combination: chCom,
          exProductReqId: rejectedProductsList[id]._id,
          taxClass: gst,
        };

        api.product
          .addToExProduct(data)
          .then((res) => {
            alert.success("Request submitted successfully");
            // Rejected Products
            api.product
              .sellerProductsRetrieveAll(
                pendingFromSellerProducts(globalFilter)
              )
              .then((res) => {
                console.log(res);
                setrejectedProductsList(res.products);
                setrejRecords(res.totalRecords);
              })
              .catch((err) => {
                console.log(err);
              });
          })
          .catch((err) => console.log(err));
      } else {
        let data = {
          _id: rejectedProductsList[id].product._id,
          purchase_price: ele.value,
          exProductReqId: rejectedProductsList[id]._id,
          taxClass: gst,
        };
        api.product
          .addToExProduct(data)
          .then((res) => {
            alert.success("Request submitted successfully");

            // Rejected Products
            api.product
              .sellerProductsRetrieveAll(
                pendingFromSellerProducts(globalFilter)
              )
              .then((res) => {
                console.log(res);
                setrejectedProductsList(res.products);
                setrejRecords(res.totalRecords);
              })
              .catch((err) => {
                console.log(err);
              });
          })
          .catch((err) => console.log(err));
      }
    }
  }

  // Clear Filters

  function clearFilters() {
    if (searchPro !== undefined && searchPro !== "") {
      applyLoader();
      setselectedPage(1);
      globalFilter = {
        pageNo: "1",
      };
      setsearchPro("");
      // Rejected Products
      api.product
        .sellerProductsRetrieveAll(pendingFromSellerProducts(globalFilter))
        .then((res) => {
          setremoveFilterClass("invent_remove_filter_btn");
          setrejectedProductsList(res.products);
          setrejRecords(res.totalRecords);
          removeLoader();
        })
        .catch((err) => {
          removeLoader();
          console.log(err);
        });
    }
  }
  const filterSearch = (data) => {
    setsearchPro(data.data);
    setSearchType(data.type)
  }

  useEffect(() => {
    checkevent({ "keyCode": 13 }, "appPro");
  }, [searchPro])
  const searchParam = {
    "tmpSts": {
      "$in": [
        "forwarded-to-seller",
        "rejected"
      ]
    }
  };

  // SL-1010(20,11,25)
  const statusFilter = (e) => {
    setCurrStatusFilter(e.value);
    applyLoader();
    setselectedPage(1);
    globalFilter.pageNo = 1;
    globalFilter.tmpSts = [e.value];
    api.product
      .sellerProductsRetrieveAll(pendingFromSellerProducts(globalFilter))
      .then((res) => {
        setrejectedProductsList(res.products);
        setrejRecords(res.totalRecords);
        removeLoader();
      })
      .catch((err) => {
        console.log(err);
        removeLoader();
      });
  }


  // l1-2607
  const handleApprove = (props) => {
    const i = props?.id
    setCurrentProp(props)
    setupdtPopuprel({
      "SKU": rejectedProductsList[i]?.SKU,
      "taxClass": rejectedProductsList[i]?.taxClass,
      "pkgs": rejectedProductsList[i]?.pkgs,
      "categories": rejectedProductsList[i]?.categories,
      "shortDescription": rejectedProductsList[i]?.shortDescription,
      "description": rejectedProductsList[i]?.description,
      "attributeList": rejectedProductsList[i]?.attributeList,
      "combination": rejectedProductsList[i]?.combination,
      "vendor": rejectedProductsList[i]?.vendors?.[0],
      "product": rejectedProductsList[i],
      "manufacturerName": rejectedProductsList[i]?.manufacturerName || "",
      "productName": rejectedProductsList[i]?.productName,
      "_id": rejectedProductsList[i]?._id
      // "productId": rejectedProductsList[i]?.
    })
    setupdtProVisibility(true)
  }

  const handleReject = (item) => {
    setupdtProVisibility(false)
    setRejectModalShow(true)
    setCurrentProp(item)
  }

  const callBackApproveReject = (type, item) => {
    handleProductUpdate(type, item, "", "", "")
  }

  const handleRejectModalClose = () => {
    setRejectModalShow(false)
  }


  return (
    <div className=" inventry-page" id="outer">
      <div className="pro_filt_cntnier d-flex">
        {/* <button className={removeFilterClass} onClick={() => clearFilters()}>
          Clear Filter
        </button> */}
        <div className='topprodsearch'>
          {/* <ProductSearch 
                filterSearch={filterSearch}
                searchNewEnq={setsearchPro}
                searchParam={searchParam}
                /> */}
        </div>
        {/* <div class="">
                      <select className="pro_approved_srch_bar pr-4" onChange={(e)=>{setSearchType(e.target.value)}}>
                        <option value="product Name">Product Name</option>
                        <option value="sku">SKU</option>
                      </select>
                    </div>
        <input
          type="text"
          placeholder="Search for products..."
          className="pro_approved_srch_bar pr-4"
          value={searchPro}
          onKeyUp={(e) => checkevent(e)}
          onChange={(e) => setsearchPro(e.target.value)}
        ></input>
        <i
          className="fa fa-search srch_pro_filt_invent"
          aria-hidden="true"
          onClick={() => searchProdBtnweb()}
        ></i> */}
        {/* <input type='text' className='pl-1 filter_pro_invent_name' readOnly placeholder='All Products'></input><i className="fa fa-chevron-right fs-10 srch_pro_filt_invent_arrow" aria-hidden="true"></i> */}

        <NavLink exact to="/add-Product1">
          <button className="pro_add_pro_invent ms-2">+ Add Product</button>
        </NavLink>
        {/* <i class="fa fa-filter" aria-hidden="true"></i> */}
      </div>

      <div className="container_invent" id="orDeskContain">
        {/* New orders desktop */}
        <div class="tab table-responsive">
          {/* <Container> */}

          <table className="ord_table" style={{ width: "100%" }}>
            <thead>
              <tr className="table_ord_title_row">
                <th className="thead_title pt-2 pb-2" style={{ width: "5%" }}>
                  Product Image
                </th>

                <th className="thead_title pb-1" style={{ width: "20%" }}>
                  Product Name<br></br>
                </th>

                <th className="thead_title" style={{ width: "7%" }}>
                  Transfer price{" "}
                  <OverlayTrigger
                    key="transfer"
                    placement="bottom"
                    overlay={
                      <Tooltip
                        id={`tooltip-transfer`}
                        className="fs-10 order_page_tooltip"
                      >
                        <p className="fs-8 f-500 order_page_tooltip_1">
                          {variables.transferPriceText}
                        </p>
                      </Tooltip>
                    }
                  >
                    <i class="bi bi-info-circle ms-1"></i>
                  </OverlayTrigger>
                </th>

                <th className="thead_title" style={{ width: "10%" }}>
                  Action
                  <br></br>
                  <Form.Select size="lg" className="pro_card_comb_box_invent mb-1" style={{ "width": "90%" }} onChange={(e) => statusFilter(e.target)} value={currStatusFilter}>
                    <option value="forwarded-to-seller">Pending</option>
                    <option value="rejected">Rejected</option>
                  </Form.Select>
                  <br></br>
                </th>
                <th className="thead_title" style={{ width: "10%" }}>
                  Reason
                </th>
              </tr>
            </thead>
            <tbody>
              {rejRecords > 0 ? (
                rejectedProductsList.map((item, index) => {
                  let baseImg;
                  item.images.map((item) => {
                    if (item.baseImage === true) {
                      if (item.image.startsWith("products")) {
                        baseImg = item.image;
                      } else {
                        let img = item.image.substr("41");

                        baseImg = img;
                      }
                    }
                  });
                  if (item.vendors[0].combination.length > 0) {
                    var offerArry = [];
                    var combarry = [];
                    var singleAttr = true;
                    if (
                      item.combination[0] &&
                      item.combination[0].value &&
                      item.combination[0].value.length > 1
                    ) {
                      singleAttr = false;
                    }
                    item.vendors[0].combination.map((vitem, vindex) => {
                      item.combination.map((pitem, pindex) => {
                        if (
                          pitem.url === vitem.url
                          // vitem.purchase_price &&
                          // vitem.purchase_price !== undefined
                          // pitem.active
                        ) {
                          if (!singleAttr) {
                            let com = "";
                            pitem.value.map((aitem, aindex) => {
                              com = com + aitem;
                              if (aindex !== pitem.value.length - 1) {
                                com = com + " x ";
                              }
                            });
                            combarry.push({
                              com: com,
                              price: vitem.purchase_price,
                              url: pitem.url,
                              tmpSts: pitem.tmpSts,
                              stock: vitem?.stock //SL-702
                            });
                          } else {
                            let com = {
                              com: pitem.value[0],
                              price: vitem.purchase_price,
                              url: pitem.url,
                              tmpSts: pitem.tmpSts,
                              stock: vitem?.stock //SL-702
                            };
                            combarry.push(com);
                          }
                        }
                      });
                    });
                    return (
                      <NotAprrPCard
                        key={item._id}
                        id={index}
                        taxClass={item.taxClass}
                        SKU={item.SKU}
                        lead={item._id}
                        productName={item.productName}
                        price={item.vendors[0].purchase_price}
                        quantity={item.quantity}
                        image={baseImg}
                        combination={combarry}
                        showButton={true}
                        remark={item.remark}
                        tmpSts={item.tmpSts}
                        detail={showDetail}
                        handleApprove={handleApprove}
                        handleReject={handleReject}
                        handleProductUpdate={handleProductUpdate}
                        sellerRemarksHistory={item.sellerRemarksHistory}
                        activePage={selectedPage}
                        from="pendingSellerApproval"
                        stock={item.vendors[0].stock != undefined ? item.vendors[0].stock : ''}
                        bulkupload={item?.bulkupload}

                      />
                    );
                  } else {
                    return (
                      <NotAprrPCard
                        key={item._id}
                        id={index}
                        taxClass={item.taxClass}
                        SKU={item.SKU}
                        lead={item._id}
                        productName={item.productName}
                        showButton={true}
                        price={item.vendors[0].purchase_price}
                        image={baseImg}
                        remark={item.remark}
                        tmpSts={item.tmpSts}
                        activePage={selectedPage}
                        handleProductUpdate={handleProductUpdate}
                        handleApprove={handleApprove}
                        handleReject={handleReject}
                        sellerRemarksHistory={item.sellerRemarksHistory}
                        detail={showDetail}
                        from="pendingSellerApproval"
                        stock={item.vendors[0].stock != undefined ? item.vendors[0].stock : ''}
                        bulkupload={item?.bulkupload}
                      />
                    );
                  }
                })
              ) : loaderProductReject ? (
                <></>
              ) : (
                <div className="card card-1">No Products</div>
              )}
            </tbody>
          </table>
          {/* </Container> */}
        </div>

        <div
          class="d-flex justify-content-center loader-bt"
          id="Loaderrejected"
        >
          <div
            class="spinner-border"
            role="status"
            style={{ display: loaderProductReject }}
          >
            <span class="sr-only"></span>
          </div>
        </div>

        <PaginationCom
          number={rejRecords}
          paginate={paginate}
          comp="actionReqPro"
          activ={selectedPage}
        />

        {/* Detail popup */}
        {rejectedProductsList.length > 0 ? (
          <div
            id="popupDetail"
            className="overlay"
            style={{ display: isDetailPopupVis }}
          >
            <PopupActionRequired
              description={rejectedProductsList[currdetailId]?.description}
              sdescription={rejectedProductsList[currdetailId]?.shortDescription}
              specificationNew={rejectedProductsList[currdetailId]?.specificationNew}
              name={rejectedProductsList[currdetailId]?.productName}
              // price={detailPPrice}
              data={rejectedProductsList[currdetailId]}
              SKU={rejectedProductsList[currdetailId]?.SKU}
              popupVisibility={setpopupVisibilityDetail}
              show={popupActReqShow}
              images={rejectedProductsList[currdetailId]?.images}
            />
          </div>
        ) : (
          <></>
        )}

        {/* l1-2607 */}
        {updtProVisibility === true ?
          currentProp?.combination?.length > 0 ?
            <ActionRequiredConfirmModalComb
              details={updtPopuprel}
              callBack={callBackApproveReject}
              handleReject={handleReject}
              curProp={currentProp}
              closeModal={() => setupdtProVisibility(false)}
            /> :
            <ActionRequiredConfirmModal
              details={updtPopuprel}
              callBack={callBackApproveReject}
              curProp={currentProp}
              handleReject={handleReject}
              closeModal={() => setupdtProVisibility(false)}
            /> : <></>
        }

        <RejectProductModal
          show={rejectModalShow}
          handleClose={handleRejectModalClose}
          setReasonText={setReasonText}
          handleConfirm={(reason) => handleProductUpdate("reject", currentProp, "", "", reason)}
        />

      </div>
    </div>
  );
};

export default ActionRequiredNewPro;
